import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getRefundReport } from "../../../actions/report";
import { getAllLocationPlain } from "../../../actions/warehouseAction";
import ReactToPrint from "react-to-print";
import dateFormat from "dateformat";
import { Row, Col, Select, Button, DatePicker, Spin, Divider, Card, Space, Typography } from "antd";

const { Option } = Select;
const { Title, Text } = Typography;

const RefundReport = ({
  getRefundReport,
  getAllLocationPlain,
  Auth,
}) => {
  var formatter = new Intl.NumberFormat("en-IN");
  const componentRef = useRef();
  const [data, setData] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setloading] = useState(false);
  const [initial, setinitial] = useState(false);
  const [reload, setreload] = useState(false);
  
  const location = useRef("");
  const start = useRef("");
  const end = useRef("");
  const total_amount = useRef(0);
  const flag = useRef(0);

  useEffect(() => {
    total_amount.current = 0;
    if (flag.current != 0) {
      getAllLocationPlain().then((res) => {
        setLocations(res);
        getRefundReport(
          start.current,
          end.current,
          location.current
        ).then((result) => {
          total_amount.current = 0;
          if (result && result.results) {
            setData(result.results);
            // Optionally could use result.total_amount
          } else {
            setData([]);
          }
          setloading(false);
        });
      });
    } else {
      setinitial(true);
      getAllLocationPlain().then((res) => {
        setLocations(res);
        setinitial(false);
      });
    }
  }, [reload]);

  return (
    <>
      <div style={{ padding: "20px", background: "#f0f2f5", minHeight: "100vh" }}>
        <Card bordered={false} style={{ marginBottom: "20px", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }} bodyStyle={{ padding: "24px" }}>
          <Title level={3} style={{ marginBottom: "24px" }}>Refund Report</Title>
          <Row gutter={[24, 24]} align="bottom">
            <Col xs={24} sm={12} md={8}>
              <Text strong style={{ display: "block", marginBottom: "8px" }}>Choose Date Range</Text>
              <DatePicker.RangePicker
                style={{ width: "100%" }}
                onChange={(dates) => {
                  start.current = dates && dates[0] ? dates[0].format("YYYY-MM-DD") : "";
                  end.current = dates && dates[1] ? dates[1].format("YYYY-MM-DD") : "";
                }}
              />
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Text strong style={{ display: "block", marginBottom: "8px" }}>Choose Location</Text>
              <Select
                placeholder="Select Location"
                style={{ width: "100%" }}
                disabled={
                  Auth.superuser ||
                  Auth.profile.user_role.id == 10 ||
                  Auth.profile.user_role.id == 36 ||
                  Auth.profile.user_role.id == 38
                    ? false
                    : true
                }
                onChange={(e) => {
                  location.current = e;
                }}
              >
                <Option value="">All</Option>
                {locations.map((outlet) => {
                  return <Option key={outlet.id} value={outlet.id}>{outlet.name}</Option>;
                })}
              </Select>
            </Col>
            <Col xs={24} sm={24} md={8} style={{ textAlign: "right" }}>
              <Space size="middle">
                <Button 
                  type="primary" 
                  size="large"
                  style={{ backgroundColor: "#ab0735", borderColor: "#ab0735", minWidth: "120px" }} 
                  onClick={() => {
                    flag.current = 1;
                    setloading(true);
                    setreload(!reload);
                  }}
                >
                  Search
                </Button>
                <ReactToPrint
                  trigger={() => (
                    <Button type="default" size="large" style={{ minWidth: "120px" }}>
                      PDF
                    </Button>
                  )}
                  content={() => componentRef.current}
                />
              </Space>
            </Col>
          </Row>
        </Card>
        
        <Card bordered={false} style={{ borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
          <Spin spinning={loading}>
            <div ref={componentRef} style={{ padding: "20px" }}>
              <div style={{ textAlign: "center", marginBottom: "30px" }}>
                <Title level={2} style={{ margin: 0 }}>Refund Report</Title>
              </div>
              <Row style={{ marginBottom: "20px" }}>
                <Col span={12} style={{ textAlign: "left" }}>
                  {start.current != "" ? (
                    <Text strong>From : {dateFormat(start.current, "mmmm dS, yyyy")}<br/></Text>
                  ) : null}
                  {end.current != "" ? (
                    <Text strong>To : {dateFormat(end.current, "mmmm dS, yyyy")}<br/></Text>
                  ) : null}
                </Col>
                <Col span={12} style={{ textAlign: "right" }}>
                  {locations.map((outlet) => {
                    if (outlet.id == location.current)
                      return <Text strong key={outlet.id}>Outlet : {outlet.name}</Text>;
                    return null;
                  })}
                </Col>
              </Row>
              
              <table className="attendacne_table" style={{ width: "100%", textAlign: "center", borderCollapse: "collapse", marginTop: "20px" }}>
                <thead>
                  <tr style={{ background: "#fafafa" }}>
                    <th style={{border: "1px solid #f0f0f0", padding: "12px 8px", fontWeight: 600}}>SL.</th>
                    <th style={{border: "1px solid #f0f0f0", padding: "12px 8px", fontWeight: 600}}>Issue Date</th>
                    <th style={{border: "1px solid #f0f0f0", padding: "12px 8px", fontWeight: 600}}>Invoice No</th>
                    <th style={{border: "1px solid #f0f0f0", padding: "12px 8px", fontWeight: 600}}>Customer</th>
                    <th style={{border: "1px solid #f0f0f0", padding: "12px 8px", fontWeight: 600}}>Outlet</th>
                    <th style={{border: "1px solid #f0f0f0", padding: "12px 8px", fontWeight: 600}}>Method</th>
                    <th style={{border: "1px solid #f0f0f0", padding: "12px 8px", fontWeight: 600}}>Reason</th>
                    <th style={{border: "1px solid #f0f0f0", padding: "12px 8px", fontWeight: 600}}>Reference</th>
                    <th style={{border: "1px solid #f0f0f0", padding: "12px 8px", fontWeight: 600}}>Amount (BDT)</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => {
                    total_amount.current += parseFloat(item.amount);
                    return (
                      <tr key={index}>
                        <td style={{border: "1px solid #f0f0f0", padding: "10px 8px"}}>{index + 1}</td>
                        <td style={{border: "1px solid #f0f0f0", padding: "10px 8px"}}>{item.issue_date}</td>
                        <td style={{border: "1px solid #f0f0f0", padding: "10px 8px"}}>{item.invoice_number}</td>
                        <td style={{border: "1px solid #f0f0f0", padding: "10px 8px"}}>{item.contact}</td>
                        <td style={{border: "1px solid #f0f0f0", padding: "10px 8px"}}>{item.outlet}</td>
                        <td style={{border: "1px solid #f0f0f0", padding: "10px 8px"}}>{item.out_method}</td>
                        <td style={{border: "1px solid #f0f0f0", padding: "10px 8px"}}>{item.reason}</td>
                        <td style={{border: "1px solid #f0f0f0", padding: "10px 8px"}}>{item.reference}</td>
                        <td style={{border: "1px solid #f0f0f0", padding: "10px 8px"}}>{formatter.format(item.amount)}</td>
                      </tr>
                    )
                  })}
                  <tr style={{ background: "#fafafa" }}>
                    <td colSpan={8} style={{border: "1px solid #f0f0f0", padding: "12px 8px", textAlign: "right"}}><b>Total Amount:</b></td>
                    <td style={{border: "1px solid #f0f0f0", padding: "12px 8px", color: "#ab0735"}}><b>{formatter.format(total_amount.current)}</b></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Spin>
        </Card>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    Auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  getRefundReport,
  getAllLocationPlain,
})(RefundReport);
